// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Aniversariantes_MesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /aniversariantes/mes/{mes}/{ano}
 *
 * Returns list of customers with birthdays in the specified month.
 */
import type { Aniversariantes_BirthdayRow } from './Aniversariantes_BirthdayRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Aniversariantes_MesResponseDados = Aniversariantes_BirthdayRow[];

export type Aniversariantes_MesResponse = ApiResponse<Aniversariantes_MesResponseDados>;

registerResponseContract('Aniversariantes_MesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_id:              { type: 'number',  required: true },
      cliente_nome:            { type: 'string',  required: true },
      cliente_data_nascimento: { type: 'string',  required: true },
      idade:                   { type: 'string',  required: true },
      idade_anos:              { type: 'number',  required: true },
      cliente_ddi:             { type: 'string',  required: false },
      cliente_ddd:             { type: 'string',  required: false },
      cliente_telefone:        { type: 'string',  required: false },
      cliente_franquia_id:     { type: 'number',  required: true },
      data_aniversario:        { type: 'string',  required: false },
      status:                  { type: 'string',  required: true },
      data_envio:              { type: 'string',  required: false },
      enviado:                 { type: 'boolean', required: true },
    },
  },
})
